// extracted by mini-css-extract-plugin
export var navigationMenu = "NavigationMenu-module--navigationMenu--d5f94";
export var navigationMenuItem = "NavigationMenu-module--navigationMenuItem--44ff0";